$.module('MM.config', function () {
  var config = {
    site: 'www-v2',
    name: '么么直播',
    version: '@VERSION@',
    fisTime: '@FIS_TIME@',
    mode: '@MODE@', //站点模式(@MODE@|develop|release|test)
    domain: {
      main: 'www.2339.com',
    },
    defaultImg: 'https://img.sumeme.com/3/3/1559108259459.png',
    //家族的默认头像地址
    familyDefaultImg: 'https://img.sumeme.com/50/2/1406172066034.jpg',
    defaultCover: 'https://img.sumeme.com/3/3/1559108259459.png',
    privType: ['', '运营', '主播', '普通用户', '客服', '经纪人'],
  };

  var mode = {
    release: {
      app: 'app.sumeme.com/2339/www-v2', //静态资源服务器域名（应用库）
      main: 'www.2339.com',
      m: 'm.2339.com',
      h5: 'h5.2339.com',
      base: 'lib.sumeme.com', //静态资源服务器域名（公用库）
      ws: 'http://ws.memeyule.com:6010', //聊天ws域名
      gs: 'gs.memeyule.com', // 游戏gs域名
      im: 'http://im.memeyule.com:6020', //IM聊天域名
      chatIm: 'https://im.2339.com',
      flash: 'flash.sumeme.com', // flash域名
      flint: 'https://flint.memeyule.com', // flint 配置
      https: {
        ws: 'ws.memeyule.com:6110', //聊天ws域名
        im: 'im.memeyule.com:6120', //IM聊天域名
        flash: 'flash.sumeme.com',
        gs: 'gs.memeyule.com:6130',
      },
      game: 'https://game.memeyule.com',
      img: 'https://img.sumeme.com', //图片地址
      mon: 'mon.memeyule.com',
      act: 'https://act.2339.com',
      brokerAdmin: 'https://broker.2339.com',
      // api: 'api.memeyule.com',//api域名
      // ws: 'ws.memeyule.com',//聊天ws域名
      // im: 'im.memeyule.com',//IM聊天域名
      // user: 'user.memeyule.com',//用户系统域名
      // pebble : 'pebble.memeyule.com',
      pay: 'pay.memeyule.com',
      // cryolite : 'cryolite.memeyule.com'
    },
    grey: {
      app: 'app.sumeme.com/2339/www-v2',
      main: 'grey.2339.com',
      m: 'grey-m.2339.com',
      h5: 'grey-h5.2339.com',
      base: 'lib.sumeme.com',
      pay: 'grey-pay.memeyule.com',
      ws: 'http://ws.memeyule.com:6010',
      gs: 'gs.memeyule.com', // 游戏gs域名
      im: 'http://im.memeyule.com:6020',
      chatIm: 'https://grey-im.2339.com',
      flash: 'flash.sumeme.com',
      flint: 'https://grey-flint.memeyule.com', // flint 配置
      https: {
        ws: 'ws.memeyule.com:6110', //聊天ws域名
        im: 'im.memeyule.com:6120', //IM聊天域名
        flash: 'flash.sumeme.com',
        gs: 'gs.memeyule.com:6130',
      },
      game: 'https://grey-game.memeyule.com',
      img: 'http://grey-img.sumeme.com', //图片地址
      mon: 'mon.memeyule.com',
      act: 'https://grey-act.2339.com',
      brokerAdmin: 'https://grey-broker.2339.com',
      // amber: 'grey-amber.memeyule.com'
      // api: 'grey-api.memeyule.com',
      // user: 'grey-user.memeyule.com',
      // pebble : 'grey-pebble.memeyule.com',
      // cryolite : 'grey-cryolite.memeyule.com'
    },
    test: {
      base: 'test-lib.sumeme.com',
      main: 'test.2339.com',
      m: 'test-m.2339.com',
      h5: 'test-h5.2339.com',
      ws: 'http://test.ws.memeyule.com:6010',
      gs: 'test-gs.memeyule.com',
      im: 'http://test.im.memeyule.com:6020',
      chatIm: 'https://test-im.2339.com',
      flash: 'http://test.flash.sumeme.com',
      flint: 'https://test-flint.memeyule.com', // flint 配置
      https: {
        ws: 'test-ws.memeyule.com:6110', //聊天ws域名
        im: 'test-im.memeyule.com:6120', //IM聊天域名
        gs: 'test-play-ws.memeyule.com:6130',
        flash: 'test-flash.sumeme.com',
      },
      game: 'https://test-game.memeyule.com',
      img: 'http://test.img.sumeme.com', //图片地址
      mon: 'test-mon.memeyule.com',
      act: 'https://test-act.2339.com',
      brokerAdmin: 'https://test-broker.2339.com',
      // amber: 'test-amber.memeyule.com'
      // ws: 'http://test.ws.memeyule.com:6001',
      // api: 'test-api.memeyule.com',
      // user: 'test-user.memeyule.com',
      // pebble : 'test-pebble.memeyule.com',
      pay: 'test-pay.memeyule.com',
      // cryolite : 'test-cryolite.memeyule.com'
    },
    dev: {
      base: 'test-lib.sumeme.com',
      main: 'test.2339.com',
      m: 'test-m.2339.com',
      h5: 'dev-h5.2339.com',
      pay: 'dev-pay.memeyule.com',
      user: 'dev-user.memeyule.com',
      ws: 'http://dev-ws.memeyule.com:6010',
      gs: 'test-gs.memeyule.com',
      chatIm: 'dev-im.2339.com',
      // chatIm:'http://localhost:9500',
      // chatIm:'dev-im.2339.com',
      flash: 'http://test.flash.sumeme.com',
      flint: 'https://test-flint.memeyule.com', // flint 配置
      https: {
        ws: 'dev-ws.memeyule.com:6110', //聊天ws域名
        gs: 'test-play-ws.memeyule.com:6130',
        flash: 'test-flash.sumeme.com',
      },
      game: 'https://test-game.memeyule.com',
      img: 'http://test.img.sumeme.com', //图片地址
      // api: 'dev-api.memeyule.com',
      // pebble : 'test-pebble.memeyule.com',
      cryolite: 'dev-cryolite.memeyule.com',
      // amber: 'test-amber.memeyule.com'
      // spark: 'dev-spark.memeyule.com',
      mon: 'test-mon.memeyule.com',
      act: 'https://dev-act.2339.com',
      brokerAdmin: 'https://dev-broker.2339.com',
    },
    local: {
      base: 'test-lib.sumeme.com',
      main: 'localhost.2339.com',
      m: 'test-m.2339.com',
      h5: 'test-h5.2339.com',
      // h5: 'http://192.168.11.160:9200',
      pay: 'test-pay.memeyule.com',
      gs: 'test-gs.memeyule.com',
      user: 'test-user.memeyule.com',
      spark: 'test-spark.memeyule.com',
      // ws: 'http://10.0.1.69:6001',
      // ws: 'http://localhost:6010',
      ws: 'http://test-ws.memeyule.com:6010',
      im: 'http://test.im.memeyule.com:6020',
      chatIm: 'test-im.2339.com',
      // chatIm:'dev-im.2339.com',
      // chatIm:'http://localhost:9500',
      // chatIm:'http://dev-im.2339.com/build',
      flash: 'http://test.flash.sumeme.com',
      flint: 'https://test-flint.memeyule.com', // flint 配置
      https: {
        chatIm: 'test-im.2339.com', //聊天ws域名
        // chatIm:'dev-im.2339.com/build',

        ws: 'test-ws.memeyule.com:6110', //聊天ws域名
        im: 'test-im.memeyule.com:6120', //IM聊天域名
        gs: 'test-play-ws.memeyule.com:6130',
        flash: 'test-flash.sumeme.com',
      },
      api: 'dev-api.memeyule.com',
      game: 'https://test-game.memeyule.com',
      img: 'http://test.img.sumeme.com', //图片地址
      amber: 'test-amber.memeyule.com',
      mon: 'test-mon.memeyule.com',
      cryolite: 'dev-cryolite.memeyule.com',
      lava: 'test-lava.memeyule.com',
      mock: 'http://mock.memeyule.com/mock/14',
      act: 'https://localhost:9100',
      // act: 'https://local-act.2339.com',
      brokerAdmin: 'https://test-broker.2339.com',
    },
  };

  config.mode = 'release';

  if (typeof CONFIG_MODE != 'undefined') {
    config.mode = CONFIG_MODE;
  }

  config[config.mode] = 1;

  config.domain = $.extend(config.domain, mode[config.mode]);
  config['blank_img'] = 'https://img.sumeme.com/59/3/1452150023355.jpg';

  config.isRelease = function () {
    return config.mode == 'release';
  };

  config.isGrey = function () {
    return config.mode === 'grey';
  };

  return config;
});
